type Values = {
  [k: string]: string;
};

export const clientValidation = (
  values: Values,
  identifierType: 'cpf' | 'cnpj'
) => {
  const objectError = {
    cpfCnpj: '',
    vehiclePlate: '',
    vehicleChassi: '',
  };

  if (identifierType === 'cpf' && values.cpfCnpj.length !== 14) {
    objectError.cpfCnpj = 'campo CPF deve conter 11 números';
  } else if (identifierType === 'cnpj' && values.cpfCnpj.length !== 18) {
    objectError.cpfCnpj = 'campo CNPJ deve conter 14 números';
  } else {
    objectError.cpfCnpj = '';
  }

  if (values.vehiclePlate.length !== 7 && values.vehicleChassi.length === 0) {
    objectError.vehiclePlate =
      'campo Placa do Veículo deve conter 7 caracteres';
  } else {
    objectError.vehiclePlate = '';
  }

  if (values.vehicleChassi.length !== 17 && values.vehiclePlate.length === 0) {
    objectError.vehicleChassi =
      'campo Chassi do Veículo deve conter 17 caracteres';
  } else {
    objectError.vehicleChassi = '';
  }

  return objectError;
};
